import {Link as RouterLink} from '@github-ui/react-router'
import {GlobeIcon} from '@primer/octicons-react'
import {Link, Truncate} from '@primer/react'

export type EnterpriseBannerProps = {
  show?: boolean
  href?: string
  businessName?: string
  isFirstEmuOwner?: boolean
  viewingAsLogin?: string
  showDataResidency?: boolean
  dataResidencyRegion?: string
}

export function EnterpriseBanner(props: EnterpriseBannerProps) {
  const {show, href, businessName, isFirstEmuOwner, viewingAsLogin, showDataResidency, dataResidencyRegion} = props

  if (!show) return null

  return (
    <div className="tmp-px-3 py-2 border-bottom color-border-muted d-flex flex-items-center lh-condensed f6 color-fg-muted no-wrap">
      <div className="flex-sm-1 text-bold">
        <GlobeIcon size={16} />
        <span className="ml-1 hide-sm">GitHub Enterprise</span>
      </div>

      <div className="ml-2 overflow-x-hidden">
        <Truncate
          title={`${showDataResidency ? `Data residency: ${dataResidencyRegion} - ` : ''} ${
            isFirstEmuOwner ? `Viewing as ${viewingAsLogin}` : `Users managed by ${businessName}`
          }`}
          maxWidth="100%"
        >
          {showDataResidency && (
            <>
              <span data-testid="data-residency-region">
                Data residency: <strong>{dataResidencyRegion}</strong>
              </span>
              <span className="mx-1">&middot;</span>
            </>
          )}

          {isFirstEmuOwner ? (
            <>
              Viewing as <strong className="ml-1">{viewingAsLogin}</strong>
            </>
          ) : (
            <>
              Users managed by{' '}
              {href ? (
                <Link as={RouterLink} to={href} muted className="text-bold ml-1">
                  {businessName}
                </Link>
              ) : (
                <strong className="ml-1">{businessName}</strong>
              )}
            </>
          )}
        </Truncate>
      </div>
    </div>
  )
}
